import {Text} from '@chakra-ui/react';
import {FC} from 'react';
import {SchemaType} from '../../CountdownDefinition';

type EyebrowProps = Pick<SchemaType, 'titleText' | 'typography'>;

export const Eyebrow: FC<EyebrowProps> = ({titleText, typography = {}}) => {
  return (
    <Text
      className="countdown-eyebrow"
      fontFamily={typography.fontFamily}
      fontSize={typography.titleFontSize}
      letterSpacing="0.1em"
      paddingBottom="1rem"
      lineHeight="1.25rem"
    >
      {titleText}
    </Text>
  );
};
